import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-date.svg";
import * as styles from "./Icon.module.scss";

type DateProps = React.SVGProps<SVGSVGElement>;

export const Date = ({ className, ...props }: DateProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
